const SimpleForm = ({children, ...props}) => {
    return <form  {...props}>
        {children}
    </form>
}

export default SimpleForm